// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-deck {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border-top: 1px solid var(--border-color);
  background: var(--background-color);
  color: var(--text-color);
  font-family: var(--font-body);
}

.voice-deck-operations {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.voice-agent-selector {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  color: var(--secondary-text-color);
  font-family: var(--font-display);
  font-size: 0.82rem;
  font-weight: 650;
}

.voice-agent-selector strong {
  overflow: hidden;
  color: var(--text-color);
  font: 600 0.86rem var(--font-body);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voice-agent-selector-button {
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-color);
  font: 600 0.86rem var(--font-body);
  cursor: pointer;
}

.voice-agent-selector-button:hover:not(:disabled) {
  color: var(--button-primary-bg);
}

.voice-agent-picker {
  display: flex;
  min-height: 0;
  flex-direction: column;
}

.voice-agent-picker-list {
  display: grid;
  gap: 8px;
  max-height: min(58vh, 520px);
  padding: 2px;
  overflow-y: auto;
}

.voice-agent-picker-row {
  display: flex;
  width: 100%;
  min-height: 54px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--card-background);
  color: var(--text-color);
  text-align: left;
  cursor: pointer;
}

.voice-agent-picker-row:hover:not(:disabled),
.voice-agent-picker-row-current {
  border-color: var(--button-primary-bg);
  background: var(--button-pill-hover-bg);
}

.voice-agent-picker-row strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.voice-agent-picker-mode {
  flex: none;
  color: var(--secondary-text-color);
  font: 600 0.68rem var(--font-mono);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.voice-agent-picker-status {
  margin: 10px 2px 0;
  color: var(--secondary-text-color);
  font-size: 0.8rem;
}

.voice-deck-status {
  flex: none;
  color: var(--secondary-text-color);
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.voice-deck-barge-in {
  flex: none;
  color: var(--warning-text);
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.voice-deck-cost {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 8px;
  justify-content: flex-start;
  color: var(--secondary-text-color);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-variant-numeric: tabular-nums;
  line-height: 1.25;
  text-align: left;
}

.voice-waveform {
  display: grid;
  gap: 8px;
  padding: 11px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background: var(--card-background);
}

.voice-spectrum-bar-input {
  background: var(--button-primary-bg);
}

.voice-spectrum-bar-output {
  background: var(--success-text);
}

.voice-spectrum-plot {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 6px;
  width: 100%;
  max-width: 560px;
  height: 40px;
  margin-inline: auto;
}

.voice-spectrum-pair {
  display: grid;
  grid-template-columns: 3px 3px;
  align-items: end;
  gap: 2px;
  height: 100%;
}

.voice-spectrum-bar {
  display: block;
  width: 3px;
  min-height: 0;
  border-radius: 1px 1px 0 0;
}

.voice-spectrum-meter {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.voice-deck-approval,
.voice-deck-warning,
.voice-deck-error {
  margin: 0;
}

.voice-deck-approval,
.voice-deck-warning,
.voice-deck-error {
  font-size: 0.8rem;
}

.voice-deck-approval {
  color: var(--warning-text);
}

.voice-deck-warning {
  color: var(--warning-text);
}

.voice-deck-error {
  color: var(--danger-text);
}

.voice-deck-controls {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex-wrap: wrap;
}

.voice-deck-controls button {
  min-height: 40px;
  padding: 7px 11px;
  border: 1px solid var(--button-light-border);
  border-radius: var(--radius-sm);
  background: var(--button-light-bg);
  color: var(--button-light-text);
  font: 600 0.78rem var(--font-body);
  cursor: pointer;
}

.voice-deck-controls button:hover:not(:disabled) {
  border-color: var(--button-primary-bg);
  background: var(--button-pill-hover-bg);
}

.voice-deck-controls .voice-deck-ptt {
  flex: 1 1 145px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--button-primary-bg);
  border-color: var(--button-primary-bg);
  color: var(--button-primary-text);
  touch-action: none;
  user-select: none;
}

.voice-deck-ptt span {
  font-family: var(--font-mono);
  font-size: 0.64rem;
  opacity: 0.8;
}

.voice-deck-controls .voice-deck-end {
  color: var(--danger-text);
  border-color: var(--danger-border);
}

.voice-agent-selector-button:focus-visible,
.voice-agent-picker-row:focus-visible,
.voice-deck-controls button:focus-visible {
  outline: 2px solid var(--button-primary-bg);
  outline-offset: 2px;
}

@media (max-width: 560px) {
  .voice-deck-operations {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }

  .voice-deck-cost {
    justify-content: flex-start;
    text-align: left;
  }

  .voice-agent-selector {
    width: 100%;
  }

  .voice-deck-controls button:not(.voice-deck-ptt) {
    flex: 1 1 calc(50% - 8px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/voice-deck.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,mCAAmC;EACnC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,+BAA+B;EAC/B,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;;EAGE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".voice-deck {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px;\n  border-top: 1px solid var(--border-color);\n  background: var(--background-color);\n  color: var(--text-color);\n  font-family: var(--font-body);\n}\n\n.voice-deck-operations {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.voice-agent-selector {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  color: var(--secondary-text-color);\n  font-family: var(--font-display);\n  font-size: 0.82rem;\n  font-weight: 650;\n}\n\n.voice-agent-selector strong {\n  overflow: hidden;\n  color: var(--text-color);\n  font: 600 0.86rem var(--font-body);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.voice-agent-selector-button {\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-color);\n  font: 600 0.86rem var(--font-body);\n  cursor: pointer;\n}\n\n.voice-agent-selector-button:hover:not(:disabled) {\n  color: var(--button-primary-bg);\n}\n\n.voice-agent-picker {\n  display: flex;\n  min-height: 0;\n  flex-direction: column;\n}\n\n.voice-agent-picker-list {\n  display: grid;\n  gap: 8px;\n  max-height: min(58vh, 520px);\n  padding: 2px;\n  overflow-y: auto;\n}\n\n.voice-agent-picker-row {\n  display: flex;\n  width: 100%;\n  min-height: 54px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--card-background);\n  color: var(--text-color);\n  text-align: left;\n  cursor: pointer;\n}\n\n.voice-agent-picker-row:hover:not(:disabled),\n.voice-agent-picker-row-current {\n  border-color: var(--button-primary-bg);\n  background: var(--button-pill-hover-bg);\n}\n\n.voice-agent-picker-row strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.voice-agent-picker-mode {\n  flex: none;\n  color: var(--secondary-text-color);\n  font: 600 0.68rem var(--font-mono);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.voice-agent-picker-status {\n  margin: 10px 2px 0;\n  color: var(--secondary-text-color);\n  font-size: 0.8rem;\n}\n\n.voice-deck-status {\n  flex: none;\n  color: var(--secondary-text-color);\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.voice-deck-barge-in {\n  flex: none;\n  color: var(--warning-text);\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.voice-deck-cost {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px 8px;\n  justify-content: flex-start;\n  color: var(--secondary-text-color);\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.25;\n  text-align: left;\n}\n\n.voice-waveform {\n  display: grid;\n  gap: 8px;\n  padding: 11px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background: var(--card-background);\n}\n\n.voice-spectrum-bar-input {\n  background: var(--button-primary-bg);\n}\n\n.voice-spectrum-bar-output {\n  background: var(--success-text);\n}\n\n.voice-spectrum-plot {\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  max-width: 560px;\n  height: 40px;\n  margin-inline: auto;\n}\n\n.voice-spectrum-pair {\n  display: grid;\n  grid-template-columns: 3px 3px;\n  align-items: end;\n  gap: 2px;\n  height: 100%;\n}\n\n.voice-spectrum-bar {\n  display: block;\n  width: 3px;\n  min-height: 0;\n  border-radius: 1px 1px 0 0;\n}\n\n.voice-spectrum-meter {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.voice-deck-approval,\n.voice-deck-warning,\n.voice-deck-error {\n  margin: 0;\n}\n\n.voice-deck-approval,\n.voice-deck-warning,\n.voice-deck-error {\n  font-size: 0.8rem;\n}\n\n.voice-deck-approval {\n  color: var(--warning-text);\n}\n\n.voice-deck-warning {\n  color: var(--warning-text);\n}\n\n.voice-deck-error {\n  color: var(--danger-text);\n}\n\n.voice-deck-controls {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.voice-deck-controls button {\n  min-height: 40px;\n  padding: 7px 11px;\n  border: 1px solid var(--button-light-border);\n  border-radius: var(--radius-sm);\n  background: var(--button-light-bg);\n  color: var(--button-light-text);\n  font: 600 0.78rem var(--font-body);\n  cursor: pointer;\n}\n\n.voice-deck-controls button:hover:not(:disabled) {\n  border-color: var(--button-primary-bg);\n  background: var(--button-pill-hover-bg);\n}\n\n.voice-deck-controls .voice-deck-ptt {\n  flex: 1 1 145px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: var(--button-primary-bg);\n  border-color: var(--button-primary-bg);\n  color: var(--button-primary-text);\n  touch-action: none;\n  user-select: none;\n}\n\n.voice-deck-ptt span {\n  font-family: var(--font-mono);\n  font-size: 0.64rem;\n  opacity: 0.8;\n}\n\n.voice-deck-controls .voice-deck-end {\n  color: var(--danger-text);\n  border-color: var(--danger-border);\n}\n\n.voice-agent-selector-button:focus-visible,\n.voice-agent-picker-row:focus-visible,\n.voice-deck-controls button:focus-visible {\n  outline: 2px solid var(--button-primary-bg);\n  outline-offset: 2px;\n}\n\n@media (max-width: 560px) {\n  .voice-deck-operations {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .voice-deck-cost {\n    justify-content: flex-start;\n    text-align: left;\n  }\n\n  .voice-agent-selector {\n    width: 100%;\n  }\n\n  .voice-deck-controls button:not(.voice-deck-ptt) {\n    flex: 1 1 calc(50% - 8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
